import SDIcon from './SDIcon'

const IconCarbonCatalog = (props) => (
  <SDIcon title='Catalog' {...props}>
    <path
    d='M26,2H8A2,2,0,0,0,6,4V8H4v2H6v5H4v2H6v5H4v2H6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H8V24h2V22H8V17h2V15H8V10h2V8H8V4H26Z'
    transform='translate(0 0)'
    />
  </SDIcon>
)

export default IconCarbonCatalog
